<template>
    <div>
        <Card back>
            <template v-slot:header>
                <div>
                    <h4 class="d-inline">لیست لاگ ها</h4>
                </div>
            </template>

            <template v-slot:content>
                <div class="row mt-2">

                    <div class="col-4">
                        <small id="LblStratDate"> تاریخ شروع</small>
                        <date-picker input-class="required form-control" color="dimgray" type="datetime"
                            v-model="stratDate" clearable :editable="true" placeholder="تاریخ شروع"></date-picker>
                    </div>

                    <div class="col-4">
                        <small id="LblEndDate"> تاریخ پایان</small>
                        <date-picker input-class="required form-control" color="dimgray" type="datetime"
                            v-model="endDate" clearable :editable="true" placeholder="تاریخ پایان"></date-picker>
                    </div>

                    <div class="col-4">
                        <button class="btn btn-success col-12 mt-4" @click="search()">جست و جو</button>
                    </div>

                </div>
                <div>
                    <BnpGrid Selectable :propsRows="propsRows" :propsColumn="propsColumn" :NoRowNum="true" :Sortable="true"
                        v-if="render">
                    </BnpGrid>
                </div>
            </template>
        </card>


    </div>

</template>

<script>
import Card from '@/components/Card/Card.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import VuePersianDatetimePicker from "vue-persian-datetime-picker"
import Loading from '@/components/Loading/Loading.vue'
export default {
    components: { Card, BnpGrid, datePicker: VuePersianDatetimePicker, Loading },

    data() {
        return {
            stratDate: '',
            endDate: '',
            propsRows: [],
            propsColumn: [
                { name: 'Tarix', label: 'تاریخ', visibility: true },
                { name: 'Saat', label: 'ساعت', visibility: true },
                { name: 'CommandName', label: 'نام متد', visibility: true },
                { name: 'FormName', label: 'نام فرم', visibility: true },
                { name: 'UserId', label: 'شناسه کاربری', visibility: true },
                { name: 'Message', label: 'پیام', visibility: true },
                { name: 'ClientIp', label: 'آی پی', visibility: true },
                { name: 'ClientInfo', label: 'اطلاعات وارد شده', visibility: true },
            ],
            render: false,
        }
    },
    beforeDestroy(){
        this.$store.state.loading = false
    },
    methods: {
        search() {
            let DataaxiosDepUser = {
                Action: 'Log/FilterLogs',
                Method: 'post',
                ArryfildValue: {
                    startDate: this.stratDate,
                    endDate: this.endDate
                },
            }
            this.$store.state.loading = true
            this.$PostData(DataaxiosDepUser).then((res) => {
                this.propsRows = res
                this.render = false
                this.$nextTick(() => {
                    this.render = true
                })
                this.$store.state.loading = false
            }).catch((err) => {
                this.$mySweetDefaultTost('عملیات ناموفق', 'خطایی رخ داد', 'error', 2000)
                console.error(err)
            }).finally(()=>{
                this.$store.state.loading = false
            })
        },
    }
}
</script>

<style scoped>

</style>